

import { lazy } from "react";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const TripDetailsView = lazy(() => import("../../trip-management/trip-billing/components/detailsView").then((module) => ({ default: module.TripDetailsView })));
const TripBillingList = lazy(() => import("../../trip-management/trip-billing/components/tripList"));
const EmployeeRouteMap = lazy(() => import("../../trip-management/trip-billing/components/tripList/components/employee-route-map"));

const BillingAuditReportRoute = [
    {
        icon: FactCheckIcon,
        name: "Billing and Audit Report",
        link: "/billing-audit-report/",
        path: "/billing-audit-report/",
        index: 20,
        superAdminView: false,
        permission: "Report-Read",
        children: [
            {
                path: "trip-billing-report",
                element: <TripBillingList />,
                permission: "Trip Billing Report-Read",
                name: "Trip Billing Report",
                link: "/billing-audit-report/trip-billing-report",
                icon: ReceiptLongIcon,
            },
            {
                path: "trip-billing-report/:id",
                element: <TripDetailsView />,
            },
            {
                path: "trip-billing-report/:id/route-map-view",
                element: <EmployeeRouteMap />,
            },
        ],
    },
];

export default BillingAuditReportRoute;